import type { MotionType } from "@repo/types";
import { useMemo } from "react";
import { useGetMotionTypes } from "./queryHooks/configHooks";

/** Get item / meeting motions mapped by id */
export const useMotionTypeMap = () => {
  const { data: motionTypes } = useGetMotionTypes();

  const motionTypeMap = useMemo(
    () =>
      motionTypes && {
        item: motionTypes.item.reduce(
          (obj, type) => ((obj[type.id] = type), obj),
          Object.create(null) as Record<string, MotionType>
        ),
        meeting: motionTypes.meeting.reduce(
          (obj, type) => ((obj[type.id] = type), obj),
          Object.create(null) as Record<string, MotionType>
        ),
      },
    [motionTypes]
  );

  return motionTypeMap;
};
